export default class ArquivoService {
  constructor(resource) {
    this._resource = resource;
  }

  getFile(bucketName, file) {
    return this._resource
      .get(`public/${bucketName}/${file}`)
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error("Não foi possível encontrar o arquivo.");
        }
      );
  }

  deleteFile(bucketName, file, id) {
    return this._resource
      .delete(`arquivo/upload/${bucketName}`, { body: { file, id } })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error("Não foi possível remover o documento.");
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/domain/web/ArquivoService.js